import { useFormik } from "formik";
import * as XLSX from "xlsx";
import { useEffect, useState } from "react";

// Internal Imports
import { Mode } from "../../../common/types/AllTypes";
import { useForm } from "../../../contexts/form";
import { IListAttribute, IListDetail, ListType, ListDetailType } from "../../../interfaces/IListado";
import globalStyle from "../../../common/styles/globalStyle.module.css";
import MarginInput from "../../../common/components/MarginInput/MarginInput";
import SelectBox from "../../../common/components/SelectBox/SelectBox";
import { COLORS } from "../../../common/constants/colors";
import GroupRow from "../../../common/components/GroupRow/GroupRow";
import Paint from "../../../common/components/Paint/Paint";
import EditTextForm from "../../../common/components/EditTextForm/EditTextForm";
import InputExcel from "../../../common/components/InputExcel/InputExcel";
import useListFrecuenciaActulizacion from "../../../hooks/useListFrecuenciaActulizacion";
import useListAttribute from "../../../hooks/useListAttribute";
import { TypeAttribute } from "../../../interfaces/IAttribute";
import { GetListBaseDetailByID, GetListBaseDetailByQuery } from "../../../services/list";
import Modal from "../../../common/components/Modal/Modal";
import { LoadingIcon } from "../../../common/constants/cssElements";
import "../ListadoClientes.css";
import ButtonGrid from "../../../common/components/ButtonGrid/ButtonGrid";
import { getError, getFile, openNotification } from "../../../common/constants/Utilities";

interface Props {
    setCanGoNext: React.Dispatch<React.SetStateAction<boolean>>;
    mode: Mode;
}


const StepThree = ({ setCanGoNext, mode }: Props) => {

    // States
    const { setListBaseForm, listBaseForm, setLoadingExcel,
        loadingExcel, downLoadExcelFromDTO, setStatusListBaseForm,
        convertIListDetail, loadingSubmit, setLoadingSubmit } = useForm();

    const { listAttribute } = useListAttribute();
    const { listFrecuency, loadingListFrecuency } = useListFrecuenciaActulizacion();
    const [errorsAttribute, setErrorsAttribute] = useState<{ row: number; attribute: string; }[]>();
    const [hasLocalExcel, setHasLocalExcel] = useState<boolean>(false);

    // Methods
    const selectTypeFile = (type: ListType) => {
        ListBaseFormik.setValues({
            query: "",
            listadoTipo: type.toString(),
            frecuenciaActualizacionID: "",
            data: ""
        })
    }

    const validations = (values: any) => {
        const errors: any = {};

        if (!values.listadoTipo) {
            errors.listadoTipo = "Requerido";
        }

        if (parseInt(values.listadoTipo) === ListType.Query) {
            if (!values.frecuenciaActualizacionID) {
                errors.frecuenciaActualizacionID = "Requerido";
            }

            if (!values.query) {
                errors.query = "Requerido";
            }
        }

        return errors;
    }

    const validateDataAttribute = (data: any[], valiMode: ListType): boolean => {
        setErrorsAttribute(undefined);
        const internalAttribute: IListAttribute[] = listBaseForm!.listadoAtributo!.sort((x, y) => x.orden - y.orden);
        // Errors
        let arrayErrorsAttribute: { row: number; attribute: string; }[] = [];

        let index = valiMode === ListType.Archivo ? 1 : 0;

        for (index; index < data.length; index++) {

            internalAttribute.forEach((attr, index2) => {
                let attribute = listAttribute.find(x => x.atributoGUID === attr.atributoGUID)!;

                if (attribute !== undefined && attribute.atributoTipo === TypeAttribute.Detalle) {
                    const element = data[index][(7 + (index2 + 1))];
                    if (!!element) {
                        if (!attribute.atributoDetalle.map(y => y.atributoValor.trim().toLowerCase()).includes(element.toString().trim().toLowerCase())) {
                            arrayErrorsAttribute.push({ row: index + 1, attribute: attribute.nombre })
                        }
                    }
                }
            })
        }

        if (arrayErrorsAttribute.length > 0) {
            setErrorsAttribute(arrayErrorsAttribute);
            return false;
        } else {
            setErrorsAttribute(undefined);
            return true;
        }
    }

    const getListDailtFromQuery = () => {
        if (!!ListBaseFormik.values.query.trim()) {
            setLoadingExcel(true);
            GetListBaseDetailByQuery(ListBaseFormik.values.query.trim())
                .then(({ data }) => {
                    let response = (data as IListDetail[]);
                    const resultList: any[] = [];
                    let canContinue: boolean = false;
                    let sheet: XLSX.WorkSheet;
                    let arraylistDetail: IListDetail[] = [];

                    response.forEach((x) => {
                        const detailMapped: any[] = [
                            x.codigo, x.nombre, x.latitud,
                            x.longitud, x.telefono1, x.telefono2,
                            x.telefono3, x.orden
                        ];
                        x.listadoDetalleAtributo?.forEach((y) => {
                            detailMapped.push(y.atributoValor);
                        })

                        resultList.push(detailMapped);
                    });

                    canContinue = validateDataAttribute(resultList, ListType.Query);

                    const resultMapped = convertIListDetail(response);
                    sheet = XLSX.utils.json_to_sheet(resultMapped);;
                    getFile(sheet);

                    if (canContinue) {
                        if (mode === 'Add') {
                            handleSetListBaseDetail(resultList, undefined, arraylistDetail, ListType.Query);
                            setListBaseForm({ ...listBaseForm!, listadoDetalle: [...arraylistDetail] });
                            ListBaseFormik.setFieldValue("data", JSON.stringify(arraylistDetail));
                        } else {
                            GetListBaseDetailByID(listBaseForm!.listadoID)
                                .then((response) => {
                                    handleSetListBaseDetail(resultList, response, arraylistDetail, ListType.Query);
                                    setListBaseForm({ ...listBaseForm!, listadoDetalle: [...arraylistDetail] });
                                    ListBaseFormik.setFieldValue("data", JSON.stringify(arraylistDetail));
                                })
                                .finally(() => {
                                    setLoadingExcel(false);
                                })
                        }

                    }
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => {
                    setLoadingExcel(false);
                })
        }
    }

    const handleSetListBaseDetail = (data: any[], response: any, arraylistDetail: IListDetail[], valiMode: ListType) => {
        let listBaseDetailDB: IListDetail[] | undefined = response?.data;

        for (let index = 0; index < data.length; index++) {
            let detail = data[index];

            if (valiMode === ListType.Archivo && index == 0) { continue; }

            let internalDetail = listBaseDetailDB?.find(x => x.codigo!.toLowerCase().trim() === detail[0].toString().toLowerCase().trim());

            const listDetail: IListDetail = {
                listadoDetalleID: mode === 'Add' || !!!internalDetail ? 0 : internalDetail!.listadoDetalleID,
                listadoID: listBaseForm!.listadoID,
                codigo: detail[0].toString(),
                nombre: detail[1].toString(),
                latitud: parseFloat(detail[2]),
                longitud: parseFloat(detail[3]),
                telefono1: detail[4]?.toString(),
                telefono2: detail[5]?.toString(),
                telefono3: detail[6]?.toString(),
                orden: parseInt(detail[7]),
                listadoDetalleTipo: mode === 'Add' || !!!internalDetail ? ListDetailType.Insertar : ListDetailType.NA,
                listadoDetalleAtributo: []
            };

            listBaseForm?.listadoAtributo?.forEach((attr, index) => {
                let interanlDetailAttribute = internalDetail?.listadoDetalleAtributo?.find(y => y.atributoGUID?.toLowerCase().trim() === attr.atributoGUID.toLowerCase().trim());
                let valor = detail[7 + (index + 1)]?.toString();

                listDetail.listadoDetalleAtributo?.push({
                    listadoDetalleAtributoID: mode === 'Add' || !!!interanlDetailAttribute ? 0 : interanlDetailAttribute.listadoDetalleAtributoID,
                    listadoDetalleID: mode === 'Add' || !!!internalDetail ? 0 : internalDetail!.listadoDetalleID,
                    listadoAtributoID: mode === 'Add' ? 0 : attr.listadoAtributoID,
                    atributoGUID: attr.atributoGUID,
                    atributoValor: valor
                })

                if (mode != 'Add' && internalDetail != null &&
                        (
                        (interanlDetailAttribute == null) ||
                        (interanlDetailAttribute != null && valor?.toLowerCase().trim() != interanlDetailAttribute.atributoValor?.toLowerCase().trim())
                        )
                    )
                {
                    listDetail.listadoDetalleTipo = ListDetailType.Actualizar;
                }

            });

            if ( internalDetail != null && listDetail.listadoDetalleTipo == ListDetailType.NA && (
                listDetail.listadoDetalleAtributo?.length != internalDetail.listadoDetalleAtributo?.length ||
                listDetail.nombre.toLowerCase().trim() != internalDetail.nombre.toLowerCase().trim() ||
                listDetail.latitud != internalDetail.latitud ||
                listDetail.longitud != internalDetail.longitud ||
                listDetail.telefono1!.toLowerCase().trim() != internalDetail.telefono1!.toLowerCase().trim() ||
                listDetail.telefono2!.toLowerCase().trim() != internalDetail.telefono2!.toLowerCase().trim() ||
                listDetail.telefono3!.toLowerCase().trim() != internalDetail.telefono3!.toLowerCase().trim() ||
                listDetail.orden != internalDetail.orden)
                )
            {
                listDetail.listadoDetalleTipo = ListDetailType.Actualizar;
            }

            arraylistDetail.push(listDetail);

        }

        if (listBaseDetailDB !== undefined && listBaseDetailDB != null) {
            let listToDelete = listBaseDetailDB.filter(objA => !arraylistDetail.some(objB => objB.listadoDetalleID === objA.listadoDetalleID));
            if (listToDelete !== undefined && listToDelete != null)
            {
                for (let index = 0; index < listToDelete.length; index++) {
                    listToDelete[index].listadoDetalleTipo = ListDetailType.Eliminar;
                    arraylistDetail.push(listToDelete[index]);
                }
            }
        }
    }

    const transFormDataToObject = (value: string) => {
        if (!!value) {
            let data: any[] = JSON.parse(value);

            let canContinue: boolean = true;
            let hasAttribute = (!!listBaseForm?.listadoAtributo && listBaseForm?.listadoAtributo.length > 0);
            let arraylistDetail: IListDetail[] = [];

            if (hasAttribute) {
                canContinue = validateDataAttribute(data, ListType.Archivo);
            }

            if (canContinue) {
                if (mode === 'Add') {
                    handleSetListBaseDetail(data, undefined, arraylistDetail, ListType.Archivo);

                    setListBaseForm({ ...listBaseForm!, listadoDetalle: [...arraylistDetail] });
                    ListBaseFormik.setFieldValue("data", JSON.stringify(arraylistDetail));

                    setHasLocalExcel(true);
                    setLoadingExcel(false);

                    openNotification('success', 'Archivo Cargado', 'El archivo ha sido cargado correctamente');
                } else {
                    GetListBaseDetailByID(listBaseForm!.listadoID)
                        .then((response) => {
                            handleSetListBaseDetail(data, response, arraylistDetail, ListType.Archivo);

                            setListBaseForm({ ...listBaseForm!, listadoDetalle: [...arraylistDetail] });
                            ListBaseFormik.setFieldValue("data", JSON.stringify(arraylistDetail));
                            setHasLocalExcel(true);
                            openNotification('success', 'Archivo Cargado', 'El archivo ha sido cargado correctamente');
                        })
                        .finally(() => {
                            setLoadingExcel(false);
                        })
                }
            } else {
                setLoadingExcel(false);
            }
        } else {
            ListBaseFormik.setFieldValue("data", value);
        }
    }

    // Form
    const ListBaseFormik = useFormik({
        initialValues: { listadoTipo: "", frecuenciaActualizacionID: "", query: "", data: "" },
        validate: validations,
        onSubmit: (values: any) => console.log(values),
    });

    useEffect(() => {
        ListBaseFormik.validateForm().then((response) => {
            if (!!listBaseForm) {
                ListBaseFormik.setValues({
                    listadoTipo: listBaseForm.listadoTipo.toString(),
                    frecuenciaActualizacionID: !!listBaseForm.frecuenciaActualizacionID ? listBaseForm.frecuenciaActualizacionID?.toString() : "",
                    query: !!listBaseForm.query ? listBaseForm.query : "",
                    data: ""
                });
            }
            if (JSON.stringify(response) == '{}') {
                setCanGoNext(true);
            } else {
                setCanGoNext(false);
            }
        });
    }, []);

    useEffect(() => {
        setListBaseForm({
            ...listBaseForm!,
            listadoTipo: parseInt(ListBaseFormik.values.listadoTipo),
            frecuenciaActualizacionID: !!ListBaseFormik.values.frecuenciaActualizacionID ? parseInt(ListBaseFormik.values.frecuenciaActualizacionID) : null,
            query: ListBaseFormik.values.query,
        });

        if (parseInt(ListBaseFormik.values.listadoTipo) === ListType.Archivo) {
            if (!!ListBaseFormik.values.data || mode === 'Update') {
                setStatusListBaseForm(true);
            } else {
                setStatusListBaseForm(false);
            }
        } else if (parseInt(ListBaseFormik.values.listadoTipo) === ListType.Query) {
            if (!!ListBaseFormik.values.frecuenciaActualizacionID && !!ListBaseFormik.values.query && (!!ListBaseFormik.values.data || mode === 'Update')) {
                setStatusListBaseForm(true);
            } else {
                setStatusListBaseForm(false);
            }
        } else {
            setStatusListBaseForm(false);
        }

    }, [ListBaseFormik.values, ListBaseFormik.isValid]);




    return (
        <div style={{ marginTop: 20 }}>
            <GroupRow>
                <MarginInput width="100%">
                    <label>Tipo de listado:</label>
                    <SelectBox
                        value={ListBaseFormik.values.listadoTipo}
                        defaultValue={listBaseForm?.listadoTipo}
                        placeholder={"Tipo de listado"}
                        disabled={false}
                        allowClear={false}
                        loading={false}
                        onChange={(value: string) => selectTypeFile(parseInt(value))}
                        options={[{ key: 'Archivo', value: '1', text: 'Archivo' }, { key: 'Query', value: '2', text: 'Query' }]}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{ListBaseFormik.errors.listadoTipo && ListBaseFormik.errors.listadoTipo}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            {ListBaseFormik.values.listadoTipo === ListType.Query.toString()

                ? (
                    <>
                        <GroupRow>
                            <MarginInput width="100%">
                                <label>Frecuencia de actualización:</label>
                                <SelectBox
                                    value={ListBaseFormik.values.frecuenciaActualizacionID}
                                    defaultValue={listBaseForm?.frecuenciaActualizacionID}
                                    placeholder={"Frecuencia de actualización"}
                                    disabled={false}
                                    allowClear={false}
                                    loading={loadingListFrecuency}
                                    onChange={(value: string) => ListBaseFormik.setFieldValue("frecuenciaActualizacionID", value)}
                                    options={listFrecuency.map(fre => ({ key: fre.nombre, value: fre.frecuenciaActualizacionID.toString(), text: fre.nombre }))}
                                    backgroundColor={COLORS.white_color2(1)}
                                    borderColor={COLORS.black_text_color3}
                                    textColor={COLORS.black_text_color1}
                                />
                                <p className={globalStyle.error}>
                                    <Paint color={COLORS.red_error2}>{ListBaseFormik.errors.frecuenciaActualizacionID && ListBaseFormik.errors.frecuenciaActualizacionID}</Paint>
                                </p>
                            </MarginInput>
                        </GroupRow>

                        <GroupRow>
                            <MarginInput width="100%">
                                <label>Query:</label>
                                <EditTextForm
                                    value={ListBaseFormik.values.query}
                                    onChange={ListBaseFormik.handleChange}
                                    backgroundcolor={COLORS.white_color2(1)}
                                    name={"query"}
                                    placeholder={"Query"}
                                    borderColor={COLORS.black_text_color3}
                                    textColor={COLORS.black_text_color1}
                                    active={true}
                                    type={'textarea'}
                                />
                                <div className="stepThree_queyButton">
                                    <ButtonGrid color={COLORS.blue_active} active={true} sizeIcon={"1.2em"} height={"30px"} width={"40px"} icon={<i className="fa-solid fa-rocket"></i>} method={() => getListDailtFromQuery()} />
                                    {mode === 'Update' &&
                                        <>
                                            <nav>&nbsp;&nbsp;</nav>
                                            <ButtonGrid color={COLORS.white_color1} background={COLORS.blue_active} active={true} sizeIcon={"1.2em"} height={"30px"} width={"80px"} icon={<i className="fa-solid fa-download"></i>} method={() => downLoadExcelFromDTO(listBaseForm?.listadoID!)} />
                                        </>
                                    }
                                </div>

                                {ListBaseFormik.errors.query &&
                                    <p className={globalStyle.error}>
                                        <Paint color={COLORS.red_error2}>{ListBaseFormik.errors.query}</Paint>
                                    </p>
                                }
                            </MarginInput>
                        </GroupRow>
                    </>
                )
                : (
                    <GroupRow>
                        <MarginInput width="100%">
                            <label>Archivo:</label>
                            <InputExcel
                                hasLocalExcel={hasLocalExcel}
                                mode={mode}
                                value={ListBaseFormik.values.data}
                                onChange={(value: string) => transFormDataToObject(value)}
                            />
                            <p className={globalStyle.error}>
                                <Paint color={COLORS.red_error2}>{ListBaseFormik.errors.data && ListBaseFormik.errors.data}</Paint>
                            </p>
                        </MarginInput>
                    </GroupRow>
                )

            }

            {!!errorsAttribute && (
                <div className="errorFileWrapper">
                    <div className="errorFileTitle">Los datos asignados a los atributos añadidos no son permitidos, puede verificar los posibles valores permitidos en el PASO 2</div>
                    <div className="stepThree_tableScroll">
                        <table className="stepThree_tableError">
                            <thead>
                                <th>Fila</th>
                                <th>Atributo</th>
                            </thead>
                            <tbody>
                                {errorsAttribute.map(value => (
                                    <tr>
                                        <td>{value.row}</td>
                                        <td>{value.attribute}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            <Modal props={{ style: { top: '-45px' } }} closable={false} width={"30%"} title={"Cargando..."} visible={loadingExcel || loadingSubmit} setVisible={!!loadingSubmit ? setLoadingSubmit : setLoadingExcel} askBeforeClose={false}>
                <div className="stepThree_loading">
                    <LoadingIcon color={COLORS.blue_main(1)} size={'3em'} />
                </div>
            </Modal>

        </div>
    );
}

export default StepThree;
